export default __webpack_public_path__ + "static/04-5eff3d0f915d2da54d300a1fd9e7b820.jpg";